import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './prepaidRechargeController.json';

const initPrepaidRechargePage = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['prepaidRechargeController/initPrepaidRechargePage'].success.default)));
};

const validatePrepaidDepositData = (req, res, ctx) => {
  return res(
    ctx.json(mockResponse(apiResponses['prepaidRechargeController/validatePrepaidDepositData'].success.default))
  );
};

export const handlers = [
  rest.post(
    getApiEndpoint('prepaidRechargeController/initPrepaidRechargePage'),
    withScenario(withAuthCheck(initPrepaidRechargePage))
  ),
  rest.post(
    getApiEndpoint('prepaidRechargeController/validatePrepaidDepositData'),
    withScenario(withAuthCheck(validatePrepaidDepositData))
  ),
];
